const reporter = (() => {
	const report = (name, data) => {
		const report = { name, url: window.location.href, time: Date.now() }

		if (data) {
			report.data = data
		}

		const body = JSON.stringify(report)

		fetch(
			'/error_report',
			{
				method: 'post',
				body,
				headers: {
					'Content-Type': 'application/json'
				}
			}
		);
	}

	return {
		report
	}
})();
